import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6967319dc9f2cb0014709f4f/investpro_daily/src/components/common/ClientSuccessPopups.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/ubuntu/download/6967319dc9f2cb0014709f4f/investpro_daily/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6967319dc9f2cb0014709f4f/investpro_daily/src/styles/index.css");
